import React, { useEffect, useState } from "react";
import "./AboutSection.scss";
import ContentSection from "../components/ContentSection";
import TwoColumnLayout from "../components/TwoColumnLayout";
import { useInViewOnce } from "../utils/useInViewOnce";
const AboutSection: React.FC = () => {
  const { ref, inView } = useInViewOnce<HTMLDivElement>({
    threshold: 0.1,
    rootMargin: "0px",
  });
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    if (inView && !animated) {
      setAnimated(true);
    }
  }, [inView, animated]);

  const leftContent = (
    <>
      <p>
        The State of the Reentry Workforce report is the National Reentry
        Workforce Collaborative’s (NRWC) first annual effort to capture the
        current landscape of reentry workforce development across the United
        States. This year’s theme, Navigating Uncertainty in the Field, reflects
        the reality that providers are operating in an environment defined by
        rapid change, including shifting federal policies, evolving funding
        priorities, and disruptive new technologies. All of this impacts not
        just how organizations plan and deliver services, but also the
        opportunities available to people coming home from incarceration.
      </p>
      <p>
        <span className="bold">
          This report was built with the field, for the field.
        </span>{" "}
        A workgroup of NRWC members was formed to think through the focus,
        design, and structure of the report. The bulk of insights contained in
        this report were gathered from a survey sent to NRWC members and other
        reentry workforce stakeholders across the country. NRWC received 153
        responses to the survey. Respondents included nonprofit organizations,
        government agencies, employers, faith-based organizations, and academic/
        research institutions, among others. The majority of responding
        organizations focus primarily on workforce development and case
        management, though they collectively represent a diverse spectrum of
        services within their communities. Interviews were also conducted with
        several national philanthropic organizations.Insights from the survey
        and interviews were supplemented with secondary research when
        appropriate.
      </p>
      <p>
        What follows is a report meant to be an actionable document, including
        an overview of where we are today, takeaways, and recommendations for
        weathering the uncertainty.
      </p>
    </>
  );

  const rightContent = <div className="about-section-right-content"></div>;

  return (
    <div
      ref={ref}
      className={`about-section-wrapper ${animated ? "animate-in" : ""}`}
    >
      <ContentSection
        id="about"
        className="about-section"
        title="About"
        description="The State of the Reentry Workforce"
      >
        <TwoColumnLayout
          leftContent={leftContent}
          leftWidth="800px"
          rightContent={rightContent}
        />
      </ContentSection>
    </div>
  );
};

export default AboutSection;
